import { UserStore, ApiStore } from '~/stores'
import { observable, computed } from 'mobx'
import { TNotification } from '~/types'

export class NotificationsStore {
  @observable
  public loading?: boolean

  @observable
  public notifications?: TNotification[]

  @computed
  get sortedNotifications() {
    return this.notifications
      ?.slice()
      .sort((a, b) => Number(b.Created) - Number(a.Created))
  }

  @computed
  get unseenNotificationsCount() {
    return this.notifications?.filter((n) => !n.Seen).length
  }

  constructor(private userStore: UserStore, private apiStore: ApiStore) {}

  public getNotifications() {
    this.loading = true

    return this.apiStore
      .getNotifications(this.userStore.userID)
      .then((notifications) => {
        this.notifications = notifications
      })
      .finally(() => {
        this.loading = false
      })
      .catch(console.error)
  }

  public setNotificationAsSeen(notificationID: string) {
    this.loading = true

    this.notifications = this.notifications.map((n) => ({
      ...n,
      Seen: n.ID === notificationID ? true : n.Seen,
    }))

    return this.apiStore
      .setNotificationAsSeen(notificationID, this.userStore.userID)
      .catch(console.error)
      .finally(() => {
        this.loading = false
      })
  }

  public deleteNotification(notificationID: string) {
    this.loading = true

    this.notifications = this.notifications.filter((t) => t.ID !== notificationID)

    return this.apiStore
      .deleteNotification(notificationID, this.userStore.userID)
      .catch(console.error)
      .finally(() => {
        this.loading = false
      })
  }
}
